export type Theme = 'light-theme' | 'dark-theme';

export type I18nLanguage = 'en' | 'es';

export const enLang: I18nLanguage = 'en';

export const esLang: I18nLanguage = 'es';

export const lightTheme: Theme = 'light-theme';

export const darkTheme: Theme = 'dark-theme';

export const THEME_KEY = 'theme';

export const LANGUAGE_APP_KEY = 'language-app';
